// Accounting › Fixed assets — Asset Categories tab (prefix aw_fac_). Batch 9 R4.
// Rules (as every mt package): no _plural keys; numbers as {{n}}; no empty value in any language.
// The tab's name and the six statuses are facommon's (aw_fa_*); every other word the tab prints is here.
export const en: Record<string, string> = {
  aw_fac_count: 'Categories: {{n}}',
  aw_fac_intro: 'Each category points at one of the Royal Decree\'s tax classes, which sets its rate ceiling, and names the three accounts its assets post to.',
  aw_fac_add: 'Add asset category',
  aw_fac_show_label: 'Show',
  aw_fac_show_all: 'Show all',
  aw_fac_show_active: 'Active',
  aw_fac_show_off: 'Switched off',
  aw_fac_col_category: 'Category',
  aw_fac_col_asset: 'Asset account',
  aw_fac_col_expense: 'Depreciation expense account',
  aw_fac_col_accum: 'Accumulated depreciation account',
  aw_fac_col_rate: 'Default rate & useful life',
  aw_fac_col_assets: 'Assets',
  aw_fac_col_actions: 'Actions',
  aw_fac_nature_depreciation: 'Depreciation',
  aw_fac_nature_amortisation: 'Amortisation',
  aw_fac_nature_none: 'Not charged (land)',
  aw_fac_inactive: 'Switched off',
  aw_fac_ceiling: '≤ {{max}}%',
  aw_fac_class_no_dep: 'not depreciated',
  aw_fac_rate_life: '{{rate}}% · {{life}} years',
  aw_fac_assets_title: 'Assets ever registered under this category, disposed ones included',
  aw_fac_edit: 'Edit',
  aw_fac_off: 'Switch off',
  aw_fac_on: 'Switch on',
  aw_fac_delete: 'Delete',
  aw_fac_empty_title: 'No asset categories yet',
  aw_fac_empty_body: 'Every asset is registered under a category. The category gives the asset its tax class, its default rate and useful life, and the three accounts it posts to, so add the categories this client\'s books keep before registering any asset.',
  aw_fac_none_shown: 'No category matches this filter.',
  aw_fac_snapshot_note: 'Registering an asset copies its category\'s accounts and rate onto it. Changing a category later moves no asset already registered; switching one off stops it being offered for new assets.',
  aw_fac_new_title: 'New asset category',
  aw_fac_edit_title: 'Edit asset category',
  aw_fac_create_btn: 'Create category',
  aw_fac_save_btn: 'Save changes',
  aw_fac_sec_class: 'Classification',
  aw_fac_sec_names: 'Name',
  aw_fac_sec_defaults: 'Depreciation defaults',
  aw_fac_sec_accounts: 'Chart of accounts mapping',
  aw_fac_f_class: 'Tax class (Royal Decree)',
  aw_fac_f_nature: 'Kind of charge',
  aw_fac_f_name_th: 'Thai name',
  aw_fac_f_name_en: 'English name',
  aw_fac_f_rate: 'Default rate (% a year)',
  aw_fac_f_life: 'Useful life (years)',
  aw_fac_f_method: 'Depreciation method',
  aw_fac_method_straight_line: 'Straight-line',
  aw_fac_f_asset: 'Asset account',
  aw_fac_f_accum: 'Accumulated depreciation account',
  aw_fac_f_expense: 'Depreciation expense account',
  aw_fac_pick: '— choose —',
  aw_fac_required: 'required',
  aw_fac_ceiling_note: 'The decree allows at most {{max}}% a year for this class. It is a ceiling, not a default.',
  aw_fac_linked_note: 'The rate and the useful life are one figure: type either and the other follows (life = 100 ÷ rate).',
  aw_fac_never_note: 'A category that is never charged (land) has no rate, no accumulated depreciation account and no depreciation expense account.',
  aw_fac_saved: 'Category saved.',
  aw_fac_switched_off: '“{{name}}” is switched off.',
  aw_fac_switched_on: '“{{name}}” is switched on.',
  aw_fac_deleted: '“{{name}}” was deleted.',
  aw_fac_delete_title: 'Delete asset category',
  aw_fac_delete_confirm: 'Delete “{{name}}”? It disappears from this list.',
  aw_fac_delete_btn: 'Delete category',
  aw_fac_in_use_hint: 'In use by {{n}} asset(s), disposed and removed ones included, so it cannot be deleted. Switching it off stops it being offered for new assets.',
};
export const zh: Record<string, string> = {
  aw_fac_count: '类别：{{n}}',
  aw_fac_intro: '每个类别对应皇家法令规定的一个税务类别（决定折旧率上限），并指定其资产记账所用的三个科目。',
  aw_fac_add: '新增资产类别',
  aw_fac_show_label: '显示',
  aw_fac_show_all: '全部',
  aw_fac_show_active: '启用中',
  aw_fac_show_off: '已停用',
  aw_fac_col_category: '类别',
  aw_fac_col_asset: '资产科目',
  aw_fac_col_expense: '折旧费用科目',
  aw_fac_col_accum: '累计折旧科目',
  aw_fac_col_rate: '默认折旧率与使用年限',
  aw_fac_col_assets: '资产数',
  aw_fac_col_actions: '操作',
  aw_fac_nature_depreciation: '折旧',
  aw_fac_nature_amortisation: '摊销',
  aw_fac_nature_none: '不计提（土地）',
  aw_fac_inactive: '已停用',
  aw_fac_ceiling: '≤ {{max}}%',
  aw_fac_class_no_dep: '不折旧',
  aw_fac_rate_life: '{{rate}}% · {{life}} 年',
  aw_fac_assets_title: '曾登记在此类别下的资产数（含已处置的）',
  aw_fac_edit: '编辑',
  aw_fac_off: '停用',
  aw_fac_on: '启用',
  aw_fac_delete: '删除',
  aw_fac_empty_title: '尚无资产类别',
  aw_fac_empty_body: '每项资产都登记在一个类别下：类别决定资产的税务类别、默认折旧率与使用年限，以及记账所用的三个科目。请先建立本客户账簿所用的类别，再登记资产。',
  aw_fac_none_shown: '没有符合此筛选的类别。',
  aw_fac_snapshot_note: '登记资产时，类别的科目和折旧率会复制到资产上。之后修改类别不会改动已登记的资产；停用的类别不再供新资产选用。',
  aw_fac_new_title: '新增资产类别',
  aw_fac_edit_title: '编辑资产类别',
  aw_fac_create_btn: '创建类别',
  aw_fac_save_btn: '保存修改',
  aw_fac_sec_class: '分类',
  aw_fac_sec_names: '名称',
  aw_fac_sec_defaults: '折旧默认值',
  aw_fac_sec_accounts: '会计科目对应',
  aw_fac_f_class: '税务类别（皇家法令）',
  aw_fac_f_nature: '计提类型',
  aw_fac_f_name_th: '泰文名称',
  aw_fac_f_name_en: '英文名称',
  aw_fac_f_rate: '默认折旧率（每年 %）',
  aw_fac_f_life: '使用年限（年）',
  aw_fac_f_method: '折旧方法',
  aw_fac_method_straight_line: '直线法',
  aw_fac_f_asset: '资产科目',
  aw_fac_f_accum: '累计折旧科目',
  aw_fac_f_expense: '折旧费用科目',
  aw_fac_pick: '— 请选择 —',
  aw_fac_required: '必填',
  aw_fac_ceiling_note: '法令规定此类别每年最多 {{max}}%。这是上限，不是默认值。',
  aw_fac_linked_note: '折旧率与使用年限是同一个数字：输入其中一个，另一个会自动填上（年限 = 100 ÷ 折旧率）。',
  aw_fac_never_note: '不计提的类别（土地）没有折旧率，也没有累计折旧科目和折旧费用科目。',
  aw_fac_saved: '类别已保存。',
  aw_fac_switched_off: '“{{name}}”已停用。',
  aw_fac_switched_on: '“{{name}}”已启用。',
  aw_fac_deleted: '“{{name}}”已删除。',
  aw_fac_delete_title: '删除资产类别',
  aw_fac_delete_confirm: '删除“{{name}}”？它将从此列表中消失。',
  aw_fac_delete_btn: '删除类别',
  aw_fac_in_use_hint: '已有 {{n}} 项资产登记在此类别下（含已处置和已移除的），因此不能删除。停用后，新资产将不再可选此类别。',
};
export const th: Record<string, string> = {
  aw_fac_count: 'จำนวนหมวด: {{n}}',
  aw_fac_intro: 'แต่ละหมวดอ้างอิงประเภทสินทรัพย์ตามพระราชกฤษฎีกา ซึ่งกำหนดอัตราสูงสุด และระบุบัญชีสามบัญชีที่สินทรัพย์ในหมวดใช้บันทึก',
  aw_fac_add: 'เพิ่มหมวดสินทรัพย์',
  aw_fac_show_label: 'แสดง',
  aw_fac_show_all: 'แสดงทั้งหมด',
  aw_fac_show_active: 'ใช้งานอยู่',
  aw_fac_show_off: 'ปิดใช้งานแล้ว',
  aw_fac_col_category: 'หมวด',
  aw_fac_col_asset: 'บัญชีสินทรัพย์',
  aw_fac_col_expense: 'บัญชีค่าเสื่อมราคา',
  aw_fac_col_accum: 'บัญชีค่าเสื่อมราคาสะสม',
  aw_fac_col_rate: 'อัตราและอายุการใช้งานเริ่มต้น',
  aw_fac_col_assets: 'สินทรัพย์',
  aw_fac_col_actions: 'การทำงาน',
  aw_fac_nature_depreciation: 'ค่าเสื่อมราคา',
  aw_fac_nature_amortisation: 'ค่าตัดจำหน่าย',
  aw_fac_nature_none: 'ไม่คิดค่าเสื่อม (ที่ดิน)',
  aw_fac_inactive: 'ปิดใช้งานแล้ว',
  aw_fac_ceiling: 'ไม่เกิน {{max}}%',
  aw_fac_class_no_dep: 'ไม่คิดค่าเสื่อม',
  aw_fac_rate_life: '{{rate}}% · {{life}} ปี',
  aw_fac_assets_title: 'จำนวนสินทรัพย์ที่เคยลงทะเบียนในหมวดนี้ รวมที่จำหน่ายแล้ว',
  aw_fac_edit: 'แก้ไข',
  aw_fac_off: 'ปิดการใช้งาน',
  aw_fac_on: 'เปิดใช้งาน',
  aw_fac_delete: 'ลบ',
  aw_fac_empty_title: 'ยังไม่มีหมวดสินทรัพย์',
  aw_fac_empty_body: 'สินทรัพย์ทุกรายการลงทะเบียนอยู่ในหมวด หมวดกำหนดประเภทตามกฎหมายภาษี อัตราและอายุการใช้งานเริ่มต้น และบัญชีสามบัญชีที่ใช้บันทึก จึงควรสร้างหมวดที่สมุดบัญชีของลูกค้ารายนี้ใช้ก่อนลงทะเบียนสินทรัพย์',
  aw_fac_none_shown: 'ไม่มีหมวดที่ตรงกับตัวกรองนี้',
  aw_fac_snapshot_note: 'เมื่อลงทะเบียนสินทรัพย์ ระบบจะคัดลอกบัญชีและอัตราของหมวดไปไว้ที่สินทรัพย์ การแก้ไขหมวดภายหลังจะไม่เปลี่ยนสินทรัพย์ที่ลงทะเบียนแล้ว และหมวดที่ปิดใช้งานจะไม่ถูกเสนอให้สินทรัพย์ใหม่',
  aw_fac_new_title: 'หมวดสินทรัพย์ใหม่',
  aw_fac_edit_title: 'แก้ไขหมวดสินทรัพย์',
  aw_fac_create_btn: 'สร้างหมวด',
  aw_fac_save_btn: 'บันทึกการแก้ไข',
  aw_fac_sec_class: 'การจัดประเภท',
  aw_fac_sec_names: 'ชื่อ',
  aw_fac_sec_defaults: 'ค่าเริ่มต้นของค่าเสื่อมราคา',
  aw_fac_sec_accounts: 'การผูกผังบัญชี',
  aw_fac_f_class: 'ประเภทตามพระราชกฤษฎีกา',
  aw_fac_f_nature: 'ลักษณะการตัดค่าใช้จ่าย',
  aw_fac_f_name_th: 'ชื่อภาษาไทย',
  aw_fac_f_name_en: 'ชื่อภาษาอังกฤษ',
  aw_fac_f_rate: 'อัตราเริ่มต้น (% ต่อปี)',
  aw_fac_f_life: 'อายุการใช้งาน (ปี)',
  aw_fac_f_method: 'วิธีคิดค่าเสื่อมราคา',
  aw_fac_method_straight_line: 'วิธีเส้นตรง',
  aw_fac_f_asset: 'บัญชีสินทรัพย์',
  aw_fac_f_accum: 'บัญชีค่าเสื่อมราคาสะสม',
  aw_fac_f_expense: 'บัญชีค่าเสื่อมราคา',
  aw_fac_pick: '— เลือก —',
  aw_fac_required: 'จำเป็น',
  aw_fac_ceiling_note: 'พระราชกฤษฎีกากำหนดอัตราสูงสุดของประเภทนี้ไว้ {{max}}% ต่อปี เป็นเพดาน ไม่ใช่ค่าเริ่มต้น',
  aw_fac_linked_note: 'อัตราและอายุการใช้งานเป็นตัวเลขเดียวกัน พิมพ์ช่องใดช่องหนึ่งแล้วอีกช่องจะคำนวณให้ (อายุ = 100 ÷ อัตรา)',
  aw_fac_never_note: 'หมวดที่ไม่คิดค่าเสื่อม (ที่ดิน) ไม่มีอัตรา ไม่มีบัญชีค่าเสื่อมราคาสะสม และไม่มีบัญชีค่าเสื่อมราคา',
  aw_fac_saved: 'บันทึกหมวดแล้ว',
  aw_fac_switched_off: 'ปิดใช้งาน “{{name}}” แล้ว',
  aw_fac_switched_on: 'เปิดใช้งาน “{{name}}” แล้ว',
  aw_fac_deleted: 'ลบ “{{name}}” แล้ว',
  aw_fac_delete_title: 'ลบหมวดสินทรัพย์',
  aw_fac_delete_confirm: 'ลบ “{{name}}” หรือไม่? หมวดนี้จะหายไปจากรายการ',
  aw_fac_delete_btn: 'ลบหมวด',
  aw_fac_in_use_hint: 'มีสินทรัพย์ {{n}} รายการลงทะเบียนในหมวดนี้ (รวมที่จำหน่ายและนำออกแล้ว) จึงลบไม่ได้ การปิดใช้งานจะทำให้หมวดนี้ไม่ถูกเสนอให้เลือกสำหรับสินทรัพย์ใหม่',
};
